import './home.scss';

import React, { useContext, useEffect, useState } from 'react';
import { useAppSelector } from 'app/config/store';
import CalendarEventComponent from 'app/modules/home/calendar-event-component';
import EmailMessageComponent from 'app/modules/home/email-message-component';
import { getBirthdayNameday } from 'app/api/birthdayNamedayApi';
import BirthdayComponent from 'app/modules/home/birthday-component';
import { getDocument } from 'app/api/documentInfoApi';
import { ToastContext } from 'app/context/ToastContext';
import LastUploadedDocumentsComponent from 'app/modules/home/last-uploaded-documents-component';

export const Home = () => {
  const { showSuccess, showError } = useContext(ToastContext);
  const account = useAppSelector(state => state.authentication.account);
  const [birthday, setBirthday] = useState(null);
  const [documentInfo, setDocumentInfo] = useState(null);

  useEffect(() => {
    getBirthdayNameday()
      .then(response => {
        setBirthday(response.data);
      })
      .catch(e => {
        console.error(e);
      });

    getDocument()
      .then(r => {
        setDocumentInfo(r.data);
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      });
  }, []);

  const formatMeniny = meniny => {
    if (meniny) {
      return meniny.replace(/,/g, ', ');
    }

    return '';
  };

  return (
    <>
      {birthday?.today && (
        <div className="cont">
          <p>
            Dnes je: <b className="ml-1">{birthday.today}.</b>
          </p>
          <p className="sm:ml-1">
            {birthday.namesForToday && (
              <>
                Meniny má <b className="ml-1">{formatMeniny(birthday.namesForToday)}</b>
              </>
            )}
          </p>
        </div>
      )}
      <div className="grid d-flex">
        {documentInfo?.text && (
          <div className="col-12">
            <div className="card">
              <span dangerouslySetInnerHTML={{ __html: documentInfo.text }}></span>
            </div>
          </div>
        )}

        <div className="col-12 md:col-6">
          <div className="card">
            <CalendarEventComponent />
          </div>
        </div>
        <div className="col-12 md:col-6">
          <BirthdayComponent data={birthday} />
          <div className="card">
            <EmailMessageComponent />
          </div>
          <div className="card">
            <LastUploadedDocumentsComponent />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
